var _style, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconColumnDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8 40",
    style: {
      enableBackground: "new 0 0 8 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.columnDivider{fill:currentColor;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    className: "st0",
    width: 1,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColumnDivider);
export default __webpack_public_path__ + "static/media/icon_column-divider.71da43a56b920cb568fd798c9b517513.svg";
export { ForwardRef as ReactComponent };